import {
  DyFormDefaultConfig, JdDyCheckConfig,
  JdDyExtraConfig,
  JdDyInfoConfig,
  JdDyInputConfig,
  JdDyPickerConfig,
  JdDyRadioConfig,
  JdDySelectConfig,
  JdDyShowType,
  JdDySuffixAction, JdTableSelect
} from './dy-form.interface';
import {merge} from 'lodash';

export const DY_CONFIG: DyFormDefaultConfig = {
  infoConfig: {
    title: '',
    placement: 'topCenter',
    iconColor: 'primary',
    bgColor: 'default'
  },
  extraConfig: {
    color: 'default',
    text: ''
  },
  showType: {
    errorIsShowInToolTip: true,
    isShowExtraInfo: false,
    isShowInfo: false
  },
  inputConfig: {
    addOnAfter: '',
    addOnBefore: '',
    prefixIcon: '',
    suffixIcon: '',
    type: 'text'
  },
  suffixAction: {
    text: '',
    column: {
      control: {xs: 18, sm: 19, md: 20, lg: 20, xl: 20, xxl: 20},
      action: {xs: 6, sm: 5, md: 4, lg: 4, xl: 4, xxl: 4}
    }
  },
  selectConfig: {
    type: 'default',
    mode: 'default',
    isSearch: false,
    content: [],
    col: 1,
    overlayMinWidth: null,
    serverSearch: false,
    labelName: '',
    displayLabel: "jdLabel"
  },
  pickerConfig: {
    dataFormat: 'yyyy-MM-dd',
    timeFormat: 'HH:mm:ss',
    showTime: false,
    range: {
      placeHolder: ['å¼å§æ¥æ', 'ç»ææ¥æ']
    }
  },
  radioConfig: {
    // type: 'level',
    content: [],
    isVertical: false
  },
  tableSelectConfig: {
    data: [],
    minWidth: null,
    // overlayWidth: null,
    selectConfig: [],
    isSearch: false,
    customDisplayLabel: null,
    customValue: null,
  },
  checkConfig: {
    content: [],
    isVertical: false
  }
};


export function inFoConfig(defaultConfig: JdDyInfoConfig, newConfig: JdDyInfoConfig): JdDyInfoConfig {
  if (newConfig) {
    const config = merge({}, defaultConfig, newConfig);
    config.bgColor = config.bgColor === 'default' && (config.iconColor === 'warn' ||
      config.iconColor === 'error') ? config.iconColor : config.bgColor;
    return config;
  }
  return defaultConfig;
}

export function extraConfig(defaultConfig: JdDyExtraConfig, newConfig: JdDyExtraConfig): JdDyExtraConfig {
  return getUConfig(defaultConfig, newConfig);
}
export function checkConfig(defaultConfig: JdDyCheckConfig, newConfig: JdDyCheckConfig): JdDyCheckConfig {
  return getUConfig(defaultConfig, newConfig);
}

export function showTypeConfig(defaultConfig: JdDyShowType, newConfig: JdDyShowType): JdDyShowType {
  return getUConfig(defaultConfig, newConfig);
}

export function inputConfig(defaultConfig: JdDyInputConfig, newConfig: JdDyInputConfig): JdDyInputConfig {
  return getUConfig(defaultConfig, newConfig);
}

export function selectConfig(defaultConfig: JdDySelectConfig, newConfig: JdDySelectConfig): JdDySelectConfig {
  return getUConfig(defaultConfig, newConfig);
}

export function pickerConfig(defaultConfig: JdDyPickerConfig, newConfig: JdDyPickerConfig): JdDyPickerConfig {
  return getUConfig(defaultConfig, newConfig);
}

export function radioConfig(defaultConfig: JdDyRadioConfig, newConfig: JdDyRadioConfig): JdDyRadioConfig {
  return getUConfig(defaultConfig, newConfig);
}

export function suffixActionConfig(defaultConfig: JdDySuffixAction, newConfig: JdDySuffixAction): JdDySuffixAction {
  return getUConfig(defaultConfig, newConfig);
}

export function tableSelectConfig(defaultConfig: JdTableSelect, newConfig: JdTableSelect): JdTableSelect {
  return getUConfig(defaultConfig, newConfig);
}

export function getUConfig<T>(defaultConfig: T, newConfig: T): T {
  if (newConfig) {
    return merge({}, defaultConfig, newConfig);
  }
  return defaultConfig;
}

